import { updateFindings } from '@process-advisor/process-miner/api/methods/findings/updateFindings'
import { setFindingsEdited } from '@process-advisor/process-miner/api/methods/findings/setFindingsEdited'
import { saveDiscoveryChildFindings} from '@process-advisor/process-miner/api/methods/findings/saveDiscoveryChildFindings'
import { processFinding } from '@process-advisor/process-miner/api/methods/findings/processFinding';
import { downloadFinding } from '@process-advisor/process-miner/api/methods/findings/downloadFinding';
import { updateFindingDetail} from '@process-advisor/process-miner/api/methods/findings/updateFindingDetail'

export const findingMethods = {
    updateFindings,
    setFindingsEdited,
    saveDiscoveryChildFindings,
    processFinding,
    downloadFinding,
    updateFindingDetail
};
